var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/assets/images/coming_soon.gif"}})])
}]

export { render, staticRenderFns }